import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { formatPopularity } from "@/utils/media";

interface MediaCardProps {
  item: MediaItem;
  rank?: number;
}

export default function MediaCard({ item, rank }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors duration-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} 影视海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-80"></div>

        {typeof rank === "number" && (
          <span className="absolute top-2 left-2 w-7 h-7 rounded-md bg-accent-500 text-background-50 text-sm font-bold flex items-center justify-center">
            {rank}
          </span>
        )}

        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-black/55 backdrop-blur text-[11px] text-white flex items-center gap-1">
          <i className="ri-star-fill text-accent-400 text-[11px]"></i>
          <span className="font-semibold">{item.rating.toFixed(1)}</span>
        </span>

        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-[11px] font-medium">
          {item.type === "movie" ? "电影" : "电视剧"}
        </span>

        <div className="absolute bottom-2 right-2 flex items-center gap-1 text-[11px] text-white/90">
          <i className="ri-fire-line text-accent-400"></i>
          <span>{formatPopularity(item.popularity)}</span>
        </div>
      </div>

      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {item.year} · {item.region}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[11px]"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}